<template>
	<div>
		<b-tabs content-class="mt-3" v-model="tabIndex">
			<b-tab title="List" active>
				<b-row class="mt-3">
					<b-col md="4">
						<b-form inline @submit.prevent="searchClock">
							<b-form-group>
								<b-input type="text" v-model="currentSearch" />

								<b-button type="submit" variant="outline-success">Search</b-button>

								<b-button v-if="searchFlag" @click.prevent="clearSearch" variant="outline-danger">Clear</b-button>
							</b-form-group>
						</b-form>
					</b-col>

					<b-col>
						<b-link :to="{ name: 'clockcreate' }" class="float-right mb-3" title="Add a new Clock">
							<b-icon font-scale="1.5" icon="plus-square"></b-icon>
						</b-link>
					</b-col>
				</b-row>

				<b-row class="mt-1">
					<b-col md="12">
						<b-table-simple bordered>
							<b-thead head-variant="light">
								<tr>
									<th>
										<a href="#" @click.prevent="sort('Name')">
											Name
											<b-icon font-scale="1.5" class="ml-3" v-if="currentSort == 'Name' &&
												currentSortDir == 'asc'
												" icon="chevron-compact-up"></b-icon>
											<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort == 'Name' &&
												currentSortDir == 'desc'
												" icon="chevron-compact-down"></b-icon>
											<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
										</a>
									</th>

									<th>
										<a href="#" @click.prevent="
											sort('CustomerName')
											">
											Customer
											<b-icon font-scale="1.5" class="ml-3" v-if="currentSort ==
												'CustomerName' &&
												currentSortDir == 'asc'
												" icon="chevron-compact-up"></b-icon>
											<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort ==
												'CustomerName' &&
												currentSortDir == 'desc'
												" icon="chevron-compact-down"></b-icon>
											<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
										</a>
									</th>

									<th><a href="#" @click.prevent="
										sort('ServiceContractDate')
										">
										Next service
										<b-icon font-scale="1.5" class="ml-3" v-if="currentSort ==
											'ServiceContractDate' &&
											currentSortDir == 'asc'
											" icon="chevron-compact-up"></b-icon>
										<b-icon font-scale="1.5" class="ml-3" v-else-if="currentSort ==
											'ServiceContractDate' &&
											currentSortDir == 'desc'
											" icon="chevron-compact-down"></b-icon>
										<b-icon font-scale="1.5" class="ml-3" v-else icon="arrow-up-down"></b-icon>
									</a></th>
								</tr>
							</b-thead>

							<b-tbody>
								<clock-list-row v-for="clock in clocks" :key="clock.Id" :clock="clock" @update="updateClock" />
							</b-tbody>
						</b-table-simple>
					</b-col>
				</b-row>

				<!-- <b-row class="mt-3">
					
					<b-col cols="4" offset="4">
			
						<b-pagination first-number last-number v-model="paging.currentPage" :total-rows="paging.totalCount" :per-page="paging.pageSize" @input="fetchClocks" limit="6" align="fill"></b-pagination> 
					</b-col>

					<b-col cols="1">
						<b-form-input debounce="1000" min="1" v-model="paging.currentPage" :max="paging.totalPages" type="number" @input="fetchClocks"></b-form-input>				
					</b-col>
				</b-row> -->

				<div class="d-flex justify-content-center mb-5">
					<b-pagination
						first-number
						last-number
						v-model="paging.currentPage"
						:total-rows="paging.totalCount"
						:per-page="paging.pageSize"
						@input="fetchClocks"
						limit="7"
						class="mr-3"
					></b-pagination> 
					<b-form-input
						debounce="1000"
						min="1"
						v-model="paging.currentPage"
						:max="paging.totalPages"
						type="number"
						@input="fetchClocks"
						style="width:100px;"
					></b-form-input>
				</div>

			</b-tab>

			<b-tab title="Map">
				<div id="map" class="map"></div>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
import ClockService from "@/api-services/clock.service";
import ClockListRow from "@/components/clock/clock-list-row";

import "leaflet/dist/leaflet.css";
import L from "leaflet";

import ExtraMarkers from "leaflet-extra-markers";
import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";

import Markercluster from "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

export default {
	name: "ClockList",

	components: {
		ClockListRow
	},

	data() {
		return {
			clocks: [],
			mapClocks: [],
			selectedClockId: null,

			currentSort: "Name",
			currentSortDir: "asc",

			currentSearch: "",
			searchFlag: false,

			paging: {
				currentPage:
					this.$route.query.p == null
						? 1
						: parseInt(this.$route.query.p),
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			},

			tabIndex: 1,
			map: null,
			tileLayer: null
		};
	},

	mounted() {
		this.initMap();
	},

	created() {
		this.urlReadState();

		this.fetchAllClocks();
	},

	methods: {
		sort(s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir =
					this.currentSortDir === "asc" ? "desc" : "asc";
			}
			this.currentSort = s;

			this.fetchClocks();
		},

		resetPaging() {
			this.paging = {
				currentPage: 1,
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			};
		},

		urlReadState() {
			let urlSort = this.$route.query.s;
			let urlSortDir = this.$route.query.d;
			let urlSearch = this.$route.query.q;

			if (urlSort || urlSortDir) {
				this.currentSortDir = (urlSortDir === undefined) ? '' : urlSortDir;
				this.currentSort = (urlSort === undefined) ? this.currentSort : urlSort;
			}

			if (urlSearch) {
				this.currentSearch = (urlSearch === undefined) ? '' : urlSearch;
				this.searchClock();
			} else {
				this.fetchClocks();
			}

		},

		urlPushState() {
			if (history.pushState) {

				var urlParams = new URLSearchParams(window.location.search);

				if (this.paging.currentPage > 1) {
					urlParams.set("p", this.paging.currentPage);

				} else {
					urlParams.delete("p");
				}

				if (this.currentSort != "Name") {
					urlParams.set("s", this.currentSort);
				} else {
					urlParams.delete("s");
				}

				if (this.currentSortDir != "asc") {
					urlParams.set("d", this.currentSortDir);
				} else {
					urlParams.delete("d");
				}

				if (this.currentSearch != "") {
					urlParams.set("q", this.currentSearch);

				} else {
					urlParams.delete("q");
				}

				let origin = new URLSearchParams(window.location.search);

				if (JSON.stringify(Array.from(urlParams)) !== JSON.stringify(Array.from(origin))) {

					var newurl =
						window.location.protocol +
						"//" +
						window.location.host +
						window.location.pathname +
						"?" +
						urlParams;
					window.history.pushState({ path: newurl }, "", newurl);
				}

			}
		},


		clearSearch() {
			if (this.searchFlag) {
				this.currentSearch = "";
				this.searchFlag = false;
				this.resetPaging();

				this.fetchClocks();
			}
		},

		searchClock() {
			if (this.currentSearch != "") {
				this.resetPaging();

				ClockService.search(this.currentSearch).then(response => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers["paging-headers"])
					);

					this.clocks = response.data;

					this.urlPushState();

					this.searchFlag = true;
				});
			}
		},

		fetchAllClocks() {
			// after showing paging, get all clocks for the map
			if (!this.mapClocks.length) {
				ClockService.getAll().then(response => {
					this.mapClocks = response.data;

					this.mapClocks.map(clock => {
						if (
							clock.Address.Latitude == null &&
							clock.Address.Longitude == null
						) {
							// so we can set the map properly
							clock.Address.Empty = true;
						}

						return clock;
					});

					this.initLayers();
				});
			}
		},

		fetchClocks() {

			ClockService.getPaged(
				this.paging.pageSize,
				this.paging.currentPage,
				this.currentSort,
				this.currentSortDir
			)
				.then(response => {
					Object.assign(this.paging, JSON.parse(response.headers["paging-headers"]));

					this.clocks = response.data;

					this.urlPushState();
				})
				.catch(error => {
					console.log("not authorized");
				});
		},

		updateClock(clockId) {
			this.$router.push({
				name: "clockupdate",
				params: { id: clockId }
			});
		},

		initMap() {
			this.map = L.map("map").setView([53.019808, -1.642562], 6);
			this.tileLayer = L.tileLayer(
				"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
				{
					maxZoom: 18,
					attribution:
						'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
				}
			);
			this.tileLayer.addTo(this.map);
		},

		initLayers() {
			let markers = L.markerClusterGroup({
				disableClusteringAtZoom: 9,
				maxClusterRadius: 50,
				animateAddingMarkers: true
			});

			let vm = this;
			this.mapClocks.forEach(clock => {
				if (clock.Address && !clock.Address.Empty) {
					let marker = L.marker([
						clock.Address.Latitude,
						clock.Address.Longitude
					])
						.bindPopup(clock.Name)
						.on("click", function (e) {
							// go to clock page
							vm.updateClock(clock.Id);
						});

					marker.on("mouseover", function (e) {
						this.openPopup();
					});
					marker.on("mouseout", function (e) {
						this.closePopup();
					});
					markers.addLayer(marker);
				}
			});
			vm.map.addLayer(markers);
		}
	},

	watch: {
		// we need to do this so the map renders after being hidden
		tabIndex: function () {
			this.$nextTick(() => {
				this.map.invalidateSize();
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/clock/clock-list.vue